/*
  Prevodi vmesnika.

  Aplikacija je nastala v slovenščini in večina vsebine (razlage vaj,
  simulacije, zaključni test) je od šole, ne od aplikacije. Tu so prevedeni
  deli, ki jih vidi vsaka šola ne glede na jezik: prijava, vpis, navigacija,
  javna stran za šole. Ključi so slovenski stavki — tako se v kodi vidi,
  kaj piše, in manjkajoč prevod vrne slovenščino, ne praznine.

  Jezik: ?lang=xx > shranjena izbira > jezik šole > sl.
*/

import { sl } from './sl.js';
import { en } from './en.js';

const DICTS = { sl, en };
export const JEZIKI = [
  { key: 'sl', label: 'Slovenščina' },
  { key: 'en', label: 'English' },
];

const KEY = 'perut-lang';
let current = 'sl';

function fromUrl() {
  try {
    // /for-schools je angleška različica predstavitvene strani.
    if (/^\/for-schools\/?$/.test(window.location.pathname)) return 'en';
    const l = new URLSearchParams(window.location.search).get('lang');
    return l && DICTS[l] ? l : null;
  } catch {
    return null;
  }
}

function stored() {
  try {
    const l = localStorage.getItem(KEY);
    return l && DICTS[l] ? l : null;
  } catch {
    return null;
  }
}

/** Nastavi jezik ob zagonu ali ob prijavi (jezik šole). */
export function initLang(solaJezik = null) {
  // Jezik šole: de/it dobita angleški vmesnik, hr slovenskega (vsebine so šolske).
  const MAP = { sl: 'sl', en: 'en', de: 'en', it: 'en', hr: 'sl' };
  current = fromUrl() ?? stored() ?? MAP[solaJezik] ?? 'sl';
  // Tudi v Node (enotski testi, skripte) — tam ni dokumenta.
  if (typeof document !== 'undefined') document.documentElement.lang = current;
  return current;
}

export function setLang(l) {
  if (!DICTS[l]) return;
  current = l;
  try {
    localStorage.setItem(KEY, l);
  } catch {
    /* ni ključno */
  }
  if (typeof document !== 'undefined') document.documentElement.lang = l;
}

export const lang = () => current;

/** Prevod; {ime} se zamenja z vrednostjo iz vars. */
export function t(key, vars) {
  const d = DICTS[current] ?? sl;
  let s = d[key] ?? sl[key] ?? key;
  if (vars) Object.entries(vars).forEach(([k, v]) => (s = s.replaceAll(`{${k}}`, String(v))));
  return s;
}

initLang();
